import React, { forwardRef } from 'react';
import QRCode from 'react-qr-code';
import { cn } from '@/utils';
interface QRCodeBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  url: string;
  children?: React.ReactNode;
  flexible?: boolean;
}
export const QRCodeBox = forwardRef<HTMLDivElement, QRCodeBoxProps>(({
  url,
  children,
  flexible = false,
  ...props
}, ref) => {
  return <div {...props} className={cn('group relative flex items-center justify-center rounded-sm bg-white p-3 cursor-pointer', flexible && 'aspect-square h-full max-h-[270px] max-w-[270px] min-h-0 w-full flex-1 shrink', props.className)}>
        {children}
        <div ref={ref} className={cn('aspect-square w-[246px]', flexible && 'size-full min-h-0 min-w-0')}>
          <QRCode id="qr-code-svg" value={url} style={{
        width: '100%',
        height: '100%'
      }} size={300} />
        </div>
      </div>;
});
QRCodeBox.displayName = 'QRCodeBox';